import ArticleIcon from "@mui/icons-material/Article";
import { ListItemIcon, Typography } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { licensesRoute } from "../navbar/routes";
import AccountMenuItem from "../account-menu/AccountMenuItem";

interface LicensesSectionProps {
  onClick?: () => void;
}

const LicensesSection: FC<LicensesSectionProps> = ({ onClick }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onAccountClick = () => {
    if (onClick) {
      onClick();
    }
    navigate(licensesRoute.path);
  };

  return (
    <AccountMenuItem disableRipple onClick={onAccountClick}>
      <ListItemIcon>
        <ArticleIcon fontSize="small" />
      </ListItemIcon>
      <Typography variant="inherit" noWrap>
        {t("header.help.licenses")}
      </Typography>
      &nbsp;
    </AccountMenuItem>
  );
};

export default LicensesSection;
